import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const resources = [
    { label: t('navSpreadsheet'), href: '/usfans-spreadsheet-guide', internal: true },
    { label: t('navGuides'), href: '/#featured', internal: true },
    { label: t('navReviews'), href: '/#review', internal: true },
    { label: t('navShipping'), href: '/#resources', internal: true },
    { label: t('navSafety'), href: '/#safety', internal: true },
  ];

  const legal = [
    { label: t('about'), href: '#' },
    { label: t('editorialPolicy'), href: '#' },
    { label: t('contact'), href: '#' },
    { label: t('privacyPolicy'), href: '#' },
    { label: t('terms'), href: '#' },
    { label: t('disclaimer'), href: '#' },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">{t('brand')}</span>
            </div>
            <p className="mt-4 max-w-md text-sm text-foreground-600 leading-relaxed">{t('footerTagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 font-heading">{t('footerResources')}</h4>
            <ul className="mt-4 space-y-2.5">
              {resources.map((r) =>
                r.internal ? (
                  <li key={r.label}>
                    <Link to={r.href} className="text-sm text-foreground-600 hover:text-foreground-950">
                      {r.label}
                    </Link>
                  </li>
                ) : (
                  <li key={r.label}>
                    <a href={r.href} className="text-sm text-foreground-600 hover:text-foreground-950">
                      {r.label}
                    </a>
                  </li>
                ),
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 font-heading">{t('footerLegal')}</h4>
            <ul className="mt-4 space-y-2.5">
              {legal.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-foreground-950">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <p className="text-xs text-foreground-500 leading-relaxed">{t('disclaimerText')}</p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">{t('copyright')}</p>
            <p className="text-xs text-foreground-400">usfanslink.beauty</p>
          </div>
        </div>
      </div>
    </footer>
  );
}